import React from 'react'

export const PagoFracaso = ( {error, onClick, reserva}) => {
    
  return (
    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0 bg-red-500/90">
       
        <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
                ⚠️
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3 className="text-base font-semibold text-gray-900 font-bebas " id="dialog-title">No se ha podido Efectuar el Pago. </h3>
                <div className="mt-2">
                  <span>
                    <span className='uppercase text-xs text-base text-zinc-800'>Error al intentar efectuar el pago. 
                      <p className='text-base font-semibold text-gray-900 font-bebas '>{error}</p>
                  </span>
                  <span className='uppercase text-xs text-base text-zinc-800'> { reserva ? `Pero su reserva ha sido tomada. ${reserva}` : null }</span>
                  
                    </span>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
            <button type="button" onClick={()=> onClick()} className="inline-flex w-full justify-center rounded-md bg-zinc-700 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-zinc-800 sm:ml-3 sm:w-auto ">Finalizar</button>
            
          </div>
        </div>
      </div>
      </div>
  )
}
export default PagoFracaso;
